export default __webpack_public_path__ + "static/win-lose-opportunity_old-34a96ab90d283aa5ef8826fc7add60cc.mp4";